import { formatHomeDesignAtHomeSlots as formatTimeSlots } from '~/components/calendar-with-filters/time-slots/helpers';
import { envConfigSelectors } from '~/selectors';
import { SelectDateTime } from '~/routes';

const eligibleSlotsFilter = (
  dateFilter,
  timeSlot,
) => timeSlot.from >= dateFilter.atHomeFrom && timeSlot.to <= dateFilter.atHomeTo;

export const config = {
  Calendar: {
    timeSlotSectionTitle: 'Choose a time slot',
    eligibleSlotsFilter,
    formatTimeSlots,
  },
  SelectDate: {
    componentDecisioner: [
      {
        supports: envConfigSelectors.selectIsNewCalendarEnabled,
        component: SelectDateTime,
      },
    ],
  },
};
